export default __webpack_public_path__ + "static/media/TheElements _20.44286247.png";